<template>
  <el-upload class="cus_file_upload" :action="fileUploadUrl" :multiple="false" :limit="limit" :list-type="listType" :show-file-list="true" :file-list="fileUploadList" :before-upload="beforeupload" :http-request="customupload" :on-success="onsuccess" :on-remove="onremove" :on-exceed="onexceed" :on-preview="onpreview">
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">仅限上传固定类型文件, 且不超过 10MB!</div>
  </el-upload>
</template>

<script>
export default {
  props: {
    limit: {
      type: Number,
      default: 1,
    },
    listType: {
      type: String,
      default: "text",
    },
    uploadFiles: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      fileUploadList: null,
      fileUploadUrl: process.env.VUE_APP_BASE_API + "/api/upload/uploadfile",
    };
  },
  watch: {
    uploadFiles: {
      handler(data) {
        this.fileUploadList = [];
        if (data != null && data.length > 0) {
          data.forEach((element) => {
            this.fileUploadList.push(element);
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeupload(file) {
      console.log("file", file.type);
      let isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt10M;
    },
    customupload(data) {
      let formData = new FormData();
      formData.append("file", data.file);
      this.$store
        .dispatch("upload/UploadFile", formData)
        .then((result) => {
          data.onSuccess(result);
        })
        .catch(() => {});
    },
    onsuccess(response, file, fileList) {
      let { fileName, fileUrl } = response;
      this.fileUploadList.forEach((element, index, array) => {
        if (element.name == fileName && element.url == fileUrl) {
          array.splice(index, 1);
        }
      });
      this.fileUploadList.push({ name: fileName, url: fileUrl });
      // 通知父组件
      this.$emit("onsuccess", { uploadFiles: this.fileUploadList });
    },
    onremove(file, fileList) {
      console.log("onremove");
      let { name, url } = file;
      this.fileUploadList.forEach((element, index, array) => {
        if (element.name == name && element.url == url) {
          array.splice(index, 1);
        }
      });
      // 通知父组件
      this.$emit("onsuccess", { uploadFiles: this.fileUploadList });
    },
    onexceed(files, fileList) {
      this.$message.error("超出文件上传个数限制!");
    },
    // 文件预览-------
    onpreview(file) {
      let { name, url } = file;
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./upload.scss");
</style>
